import type { IClientCacheStorage } from '../../services/clients/ClientCacheStorage';
import type { ProGroupsUiStateStorage } from './ProGroupsUiStateStorage';

export class WebClientCacheStorageAdapter implements IClientCacheStorage {
  private uiStateStorage: ProGroupsUiStateStorage;

  constructor(uiStateStorage: ProGroupsUiStateStorage) {
    this.uiStateStorage = uiStateStorage;
  }

  async loadTabState<T>(tabKey: string): Promise<T | null> {
    return this.uiStateStorage.loadTabState<T>(tabKey);
  }

  async saveTabState<T>(tabKey: string, value: T): Promise<void> {
    await this.uiStateStorage.saveTabState<T>(tabKey, value);
  }

  async clearAllTabs(): Promise<void> {
    await this.uiStateStorage.clearAllTabs();
  }
}
